var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNssClub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 1600",
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(749)",
    d: "m0 0h101l64 8 37 6 41 9 30 8 29 9 32 11 39 16 18 8 36 18 23 13 22 13 17 11 15 10 18 13 16 12 14 11 17 14 11 10 8 7 10 9 17 16 11 11 7 8 8 8 7 8 9 10 9 11 14 17 15 20 13 18 14 21 15 24 15 26 13 25 8 16 9 19 15 36 10 27 12 38 10 38 8 37 6 36 6 51 2 19v85l-6 56-7 48-8 38-8 32-12 39-11 31-13 32-15 33-11 22-12 22-16 27-16 25-12 17-8 11-12 16-11 14-11 13-9 11-15 16-9 10-33 33-8 7-11 10-11 9-14 12-17 13-16 12-19 13-15 10-21 13-26 15-23 12-16 8-21 10-31 13-29 11-37 12-38 10-41 9-37 6-57 7-9 1h-94l-67-8-38-6-42-9-30-8-29-9-32-11-34-14-24-11-29-14-29-16-28-17-15-10-19-13-19-14-14-11-16-13-14-12-12-11-8-7-10-10-3-2v-2l-4-2-8-8-7-8-13-13-7-8-13-15-9-11-13-16-14-19-12-17-16-24-13-21-16-28-17-33-12-26-12-29-13-35-11-34-9-34-8-36-7-41-6-50-2-20v-91l8-67 7-41 8-36 9-34 14-43 12-31 12-29 7-15 15-30 13-23 14-24 11-17 8-12 11-16 24-32 11-13 9-11 13-15 7-7 1-2h2l2-4 37-37 8-7 13-12 11-9 13-11 13-10 19-14 17-12 21-14 18-11 15-9 23-13 16-8 29-14 31-13 29-11 36-12 37-10 30-7 38-7 43-6z",
    fill: "#322764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(784,310)",
    d: "m0 0h27l34 2 37 5 26 5 30 8 33 11 24 10 25 12 21 11 23 14 23 16 13 10 11 9 13 11 15 14 20 20 7 8 11 13 11 14 11 15 14 21 12 20 14 27 10 21 12 31 8 25 10 40 5 30 3 29 1 14v51l-3 36-5 32-7 31-7 24-10 29-11 26-12 25-14 24-11 18-14 20-14 18-11 13-7 8-9 10-23 23-11 9-11 10-17 13-14 10-15 10-20 12-22 12-25 12-33 13-28 9-28 7-32 6-33 4-34 2h-19l-32-2-26-3-30-5-23-5-32-9-31-11-30-13-20-10-24-14-19-12-18-13-18-14-10-9-8-7-12-11-18-18-7-8-9-10-8-10-14-18-16-24-11-18-12-22-14-29-12-31-10-31-7-28-6-33-4-34-1-15v-51l3-34 5-33 7-31 8-27 9-26 11-26 8-17 12-22 10-17 14-21 10-14 11-14 24-28 27-27 11-9 10-9 17-13 18-13 22-14 23-13 28-14 32-13 33-11 32-8 27-5 31-4z",
    fill: "#FEFEFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,923)",
    d: "m0 0h18l10 3 10 6 8 8 6 10 4 13v15l-4 12-8 11-7 6-20 10 1 7 11 26 10 30 5 22 4 24 2 21v34l-3 32-4 21-4 7h-9l-43-7-37-8-29-8-29-10-25-11-20-10-22-14-16-11-7-6-1-5 4-9 13-18 11-15 8-10 12-14 20-20 8-7 14-12 16-12 17-12 17-11 14-8 5-5 5-7 1-10-2-11v-11l3-10 6-10 7-7 13-7z",
    fill: "#DC252E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,830)",
    d: "m0 0 16 2 14 7 5 4 8 11 4 10 2 10-1 13-4 11-7 10-9 8-10 5-8 2h-14l-14-4-7-3-4 1-6 13-11 26-12 22-11 18-14 19-13 15-19 19-11 9-15 12-8 7-10 8-3 2h-10l-6-4-6-7-8-14-8-12-11-17-8-13-15-26-12-24-12-29-8-24-5-21-4-22-1-13 4-5 10-4 28-5 18-2 18-1h24l31 2 38 5 33 7 26 6 5-5 6-9 9-10 10-6 9-3z",
    fill: "#DC252E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1136,526)",
    d: "m0 0h6l6 7 12 19 16 27 12 22 14 29 11 28 7 21 7 28 6 34 1 11-2 7-6 5-18 4-27 3h-32l-33-3-33-5-28-6-26-7-22-7-5 1-5 5-8 11h-2v2l-9 6-9 4-6 1h-13l-12-3-10-6-9-9-7-14-2-9v-11l3-12 7-12 10-9 9-5 13-3h8l12 3 10 5 5 3 4 1 2-9 8-18 12-22 16-24 11-14 9-10 1-2h2l2-4 19-19 11-9 15-12 20-14 14-8z",
    fill: "#DC252E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(866,916)",
    d: "m0 0h19l13 5 8 6 7 8 6 12 2 6v16l-5 14-5 8 1 3 14 6 20 8 16 8 17 10 14 10 16 13 11 9 27 27 9 11 14 18 10 16 2 4-1 7-11 9-12 8-23 15-25 15-33 17-23 10-27 10-28 8-15 3-26 3-8-1-4-6-4-19-3-23-1-15v-34l2-31 4-29 8-36 7-27v-10l-10-8-8-7-6-7-5-10-1-5v-18l3-10 6-10 6-7 14-8z",
    fill: "#DC252E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(953,813)",
    d: "m0 0h16l12 4 9 6 8 9 7 14 3 8 4-1 24-10 20-7 22-6 24-5 28-3h44l31 4 22 4 4 2 1 2v11l-7 39-8 34-8 28-11 31-12 27-12 23-10 16-11 12-10 6-5 1h-7l-11-3-10-6-16-13-20-18-18-18-9-11-11-13-14-19-14-21-14-23-7-11-3-3h-9l-8 2h-15l-11-3-11-7-9-10-5-10-2-7v-16l4-13 6-9 5-6 13-8z",
    fill: "#DC252E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(828,357)",
    d: "m0 0h11l41 8 40 10 22 7 28 10 24 11 23 12 16 11 14 10 12 9 2 3-1 7-10 16-10 13-8 10-9 10-7 8-21 21-11 9-17 14-18 13-15 10-21 13-18 11-3 1 2 10 2 6v16l-3 10-6 10-5 6-8 6-10 5-8 2h-13l-13-4-10-6-9-10-5-10-2-6-1-7v-8l3-13 6-10 8-8 12-7 13-4h2l-10-21-10-28-7-27-5-32-2-31 1-30 4-33 4-17 4-5z",
    fill: "#DC252E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(518,178)",
    d: "m0 0 9 2 15 5 2 3-21 10-1 4 13 27 13 28 18 38 7 16-7-1-20-7-6-5-9-19-1-1-8 12-9 8-11 5-11 2h-17l-16-4-12-6-9-8 1-3 8-4 5-8 1-3v-7l-2-7-4-2-9-4-6-1-19 11-27 21v3l4 4 10 13 11 14 14 18 13 16 10 13 12 16v1l-16-1-15-2-9-9-7-9-33-42-10-13-3-4-5 1-16 11-8 6-10 10-4 5 2 4 15 15 8 7 7 7-2 4-11 12-7 8-9 9-7 8-3 5-1 4v9l4 8 5 5 9 3 11-1 10-4 11-8 7-8 4-9 2-9 1-12 1-1 19 1 2 1v10l-5 19-6 11-11 12-10 8-12 5-6 1h-14l-16-3-13-5-4-2-1 11-4 10-7 9-9 8-11 5-13 3h-10l-13-4-14-9-9-6-4 1-9 15-7 13-1 5 6 2 27 14 20 11 16 8 29 15 10 5-1 3-26 8h-6l-35-18-19-10-31-16h-3l-8 13-13 33 5-1h25l11 3 9 6 5 7 2 6v17l29-6 41-10h4l-2 4-33 14-27 9-26 6-7 1h-15l-6-6v-6l3-5 2-1 11-1v-9l-3-8-7-6-13-4h-12l-13 33-5 4-12 5-8 3 1-6 11-29 13-35 5-15 9-15 8-15 8-16 8-17 7-14 5-4 10-16 18-27 6-15 10-10 7-8 15-16 7-7 7-8 7-7 7-8 16-17 7-8-7-1-16-6-11-8-5-8-1-3v-12l4-8 8-7 11-5h21l23 5 23 9 4-1 14-11 15-12 18-11 42-26 18-10 29-14z",
    fill: "#FEFEFD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(719,369)",
    d: "m0 0h7l4 2 4 8 4 17 3 20 2 21 1 27-2 31-4 32-5 28-7 31v5l5 5 11 7 7 7 8 16 1 7-1 13-5 12-6 8-4 5-10 7-9 3-12 1-12-2-14-7-10-11-6-13-1-5v-12l3-12 4-8-1-5-27-11-18-8-18-10-18-12-12-9-11-9-13-12-17-17-7-8-13-16-9-13-1-2v-8l3-5 11-9 18-13 15-10 24-15 28-15 26-12 29-11 24-7z",
    fill: "#DC252E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,543)",
    d: "m0 0h7l10 5 18 13 14 11 12 11 8 7 11 11 7 8 9 10 13 17 10 13 17 26 13 21 6 5 12-1 7-1h8l13 3 8 4 9 8 7 12 2 7 1 12-2 12-6 12-7 8-9 6-11 4-5 1h-12l-13-4-9-6-8-9-6-12-3-7-3-1-17 7-20 8-23 7-24 5-21 3-13 1h-36l-29-3-19-3-10-4-1-1v-11l7-39 8-35 9-30 10-28 12-26 9-17 11-18 10-14 7-7z",
    fill: "#DC252E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1060,162)",
    d: "m0 0 5 1 29 13 34 15 19 9 15 9 21 12 20 12 20 14 14 10 2 1-3-26-5-19-6-12-5-6-6-5v-19l5 1 8 6 6 7 5 10 4 14 2 16 3 38 5 5 11 8 11 9 12 11 7 7 8 7 16 15 7 7 8 7 12 13 11 14 13 15 11 12 12 16 28 42 11 18 14 26 15 27 11 24 13 32 2 6-9 24-3-1-6-16-3-5-5 1-25 10-82 34h-3l3-10 7-17 6-5 45-19 37-15 7-2-4-12-7-16-6-11v-2l-7 2-22 12-26 14-28 15-22 12-3 2h-3l2-10 6-19 4-4 24-13 10-6-7-11-13-20-6 1-8 4h-5l-5-6-1-3v-9l5-21 5-7 7-5h6l7 8 34 51-1 8 24-12 7-4h2l-4-10-6-11-22-33-11-16-10-12-7-11-5-6-4 1-17 14-14 12-10 8-13 11-11 9-17 14-10 8h-1l1-18 1-13 5-6 10-8 13-11 11-9 6-5-1-4-16-15-5-5-3-1-1 5-6 9-6 5-6 2h-13l-10-5-6-5-6-9-4-12-1-6v-23l2-10h3l1 1 2 21 3 10 6 9 7 4 10 1 10-5 5-7 2-11-1-11 5 2 14 14 8 7 7 7 8 7 3 3-1 9-1 4 6-4 14-11 3-4-8-12-11-12-8-7-17-16-8-8-8-7-7-7-8-7-7-7-19-13-4-2-10 13-13 18-42 57-8 10h-1l-4-22-1-9 4-7 12-16 28-38 13-18 2-4-13-10-22-13h-2l-9 16-15 25-13 22-15 25-10 16h-2l-7-25v-7l11-19 1-3-4 1-17-1-14-7-9-8-7-10-6-12-4-17v-15l1-2 5 1 6 2h9l9-3 2-4 2-6v-8l-3-8-7-4-13-7-4-8-5-14z",
    fill: "#FEFEFD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(665,69)",
    d: "m0 0h9l11 3 12 6 11 9 14 12 17 16 5 4 16-1h93l65 7 37 7 17 4 6 4 11 17v2l-10-1-11-2h-4l-23 110-2 9-2 1-11-16-6-10 1-11 17-81 1-8-19-4-24-3-4 40-9 83-4-2-14-17-4-7 3-25-8 4-9 2h-16l-15-5-11-8-11-12-5-10-1-5v-7l3-10 7-8 9-3h11l12 3 8 4 13 13v2l-7-1-12-3h-10l-7 3-7 6-4 11 2 8 6 3h17l12-4 11-6 13-8h2l4-39 1-5-27-2h-72l-26 2 10 95 3 28-4-1-15-12-6-5-2-5-3-26v-9l-15 9-13 4h-18l-14-1-5 3 2 5 9 10 8 7 12 12 8 7 5 6-3 1-19-13-19-14-14-12-12-12-8-11-3-7 1-5 5-5h6l8 9 6-1 4-5 2-6v-7l-3-11-5-12-10 1-19 4-7-1-17-12v-2l15-4 58-13 31-5 25-3v-2l-7-8-15-12-15-8-13-4h-11l-13-13v-3z",
    fill: "#FEFEFD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(257,1107)",
    d: "m0 0h16l10 4 8 6 7 8 6 12 2 7v12l-3 10-6 9-5 5-10 8-11 7-19 12-9 4-5 1h-14l-11-4-10-8-7-10-5-12-1-4v-12l4-11 6-9 12-10 16-10 15-10z",
    fill: "#FEFEFD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1397,898)",
    d: "m0 0 10 2 89 23 11 3 1 1-1 9-3 9-7-1-64-16h-3l3 3 21 13 22 13 20 12 1 1-1 8-2 4-3 1-74 2v2l18 6 51 13 1 1-1 10-3 8-8-1-66-17-37-10-1-5 6-21 92-1-5-5-28-15-18-10-26-14-2-2 1-7 5-18z",
    fill: "#FEFEFD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(747,1397)",
    d: "m0 0h15l23 1 11 2 9 5 7 8 3 7 1 6v9l-3 10-6 8-8 5 10 8 5 9 1 5 1 26 2 9h-17l-4-2-1-2-1-29-2-8-4-5-5-2-20-1-1 41-1 6h-18l-1-1 1-41 2-72z",
    fill: "#FEFEFD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(329,1177)",
    d: "m0 0 4 1 11 12-1 7-11 30-14 37-3 9 7-4 9-9 8-7 16-15 3-3h2l1-3 8-7 5-3 11 12-1 5-8 7-9 9-8 7-11 11-8 7-17 16-10 9-8 8-4 2-12-12-1-5 15-40 10-27 4-12-6 4-10 9-12 11-15 14-13 12h-3l-10-10-1-5 3-3h2v-2l8-7 17-16 13-12 16-15 13-12 9-8z",
    fill: "#FEFEFD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(182,798)",
    d: "m0 0h14l1 7v13l-25 15-26 15-21 13v2l42-2 32-2 2 3 1 15-3 2-101 7h-12l-1-6v-14l8-5 54-32 10-7 1-2-60 4h-16l-1-1-1-15 3-3z",
    fill: "#FEFEFD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(422,1267)",
    d: "m0 0 4 1 14 11-6 17-37 92-3 3-13-10-1-1 1-7 7-16 1-4-4-2-13-10-7-5-4 1-16 12-4 2-9-8-5-4 2-4 14-10 12-9 19-14 12-9 18-13z",
    fill: "#FEFEFD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(91,920)",
    d: "m0 0 33 1 73 3 14 1 3 9 2 12-17 10-20 11-23 13-24 13-18 10h-4l-4-15 1-4 22-12h2l-3-7-6-23v-2h-25l-3-5-3-12z",
    fill: "#FEFEFD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1328,1088)",
    d: "m0 0 5 2 25 16 34 22 20 13 14 9-5 10-5 7-9-5-22-14-10-6-3-1-2 5-14 22-3 5v3l15 10 20 13 4 3-2 6-6 9-1 2-5-2-25-16-26-17-25-16-17-11 1-4 7-11 3-2 18 11 17 11 6 4 3-1 12-19 8-12-1-3-22-14-18-12 1-5z",
    fill: "#FEFEFD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1204,1249)",
    d: "m0 0 11 1 10 5 6 7-4 4-8 6h-5l-6-4-9-1-7 3-5 5-1 3v9l3 6 6 5 3 1h8l17-4 13-3h13l9 3 10 9 5 8 2 11-2 10-5 9-8 9-11 7-13 4h-10l-10-4-8-6-1-4 9-8 4-3 4 2 8 5h10l8-4 5-6 1-8-3-8-5-5-7-3-12 1-23 6-13 1-10-3-10-9-5-10-1-4v-8l3-10 6-10 8-7 14-7z",
    fill: "#FEFEFD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(596,1365)",
    d: "m0 0h9l16 4 9 6 7 8 4 9v14l-2 4-4-1-11-3-2-2v-11l-5-8-7-4h-9l-7 4-4 8v9l6 9 8 8 11 9 7 10 3 7v14l-4 11-9 10-11 4h-15l-13-4-10-6-8-9-4-10v-13l2-5 6 1 10 3 2 3v13l4 6 6 4 3 1h11l6-4 3-6 1-10-3-7-7-8-16-14-7-10-3-10 1-11 6-12 7-6 8-4z",
    fill: "#FEFEFD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1109,1313)",
    d: "m0 0h3l5 10-1 4-16 8-19 10 2 6 12 23 5-1 25-13 4 1 5 8-1 4-19 10-10 5 1 5 13 25 2 3 5-1 19-10 13-7 4 2 4 8-1 4-16 8-23 12-13 7h-3l-34-64-15-28-4-8 2-4 27-14 22-12z",
    fill: "#FEFEFD"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1270,1181)",
    d: "m0 0h12l10 4 7 6-4 6-7 7-5-1-7-3h-9l-7 4-4 5-2 7 1 8 4 7 17 17 8 7 14 12 8 4 9 1 7-3 6-5 3-6v-8l-5-8-2-5 10-11 3-1 5 5 6 10 1 3v12l-4 10-6 9-9 9-12 6-4 1h-12l-11-4-11-7-15-14-8-7-7-6-7-9-5-9-1-4v-16l4-9 6-9 10-9 10-5z",
    fill: "#FEFEFD"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1363,1012)",
    d: "m0 0 9 3 4 2-1 5-14 32-1 4 6 2 23 10h2l7-17 7-14 5 1 8 4-2 6-11 25 1 3 29 13 5 1 1-5 15-33 5 1 8 4-1 5-20 45-4 7-5-1-27-12-40-18-32-14-2-4 9-19 9-20z",
    fill: "#FEFEFD"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1018,1357)",
    d: "m0 0h8l8 2 9 6 7 10 1 6-12 5-4 1-3-3-6-8-4-2h-11l-10 5-3 5-1 4v8l5 17 11 30 6 11 7 5 3 1h7l8-3 4-1 3-6v-16l2-2 11-4 5 1 2 7v11l-3 9-6 8-11 7-11 4-6 1h-11l-12-4-10-9-6-10-13-36-4-14v-16l4-10 6-8 11-7 12-4z",
    fill: "#FEFEFD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,1384)",
    d: "m0 0 59 10 1 1v11l-2 3-27-4-15-2-5 29v3l20 4 13 2 1 1v10l-2 4-32-5h-3l-6 33v3l13 3 28 5v8l-1 6-11-1-48-8-3-1v-8l16-92 3-14z",
    fill: "#FEFEFD"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1404,815)",
    d: "m0 0 13 1 1 4-3 38 1 1 33 3v-9l2-25 3-2 10 1 2 2-2 26v8l37 4 3-37 1-6h11l3 1-1 22-3 34-1 6h-11l-102-9-2-1v-13l4-48z",
    fill: "#FEFEFD"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(908,1389)",
    d: "m0 0h7l-2 16-13 82-3 18-2 3-13 2h-6l-5-8-19-45-18-43-5-12v-3l14-2h5l4 8 16 45 13 36 3 2 4-36 6-56 1-5z",
    fill: "#FEFEFD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(263,1125)",
    d: "m0 0h13l8 6 5 8 1 4v7l-3 8-4 5-14 10-17 11-11 7-8 3h-11l-8-4-6-8-2-6v-8l5-10 11-9 17-11 16-10z",
    fill: "#332764"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(304,351)",
    d: "m0 0 4 2 10 9 5 4-1 4-12 13-10 11-7 11-2 7v11l1 7-7-2 1 7-5 2-51 9h-2l1-4 12-19 10-14 9-11 22-24 16-17z",
    fill: "#322764"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1101,201)",
    d: "m0 0 16 6 25 13 15 9-1 6-13 22-8 13-2 1h-8l-17 3h-9l-9-2-9-6-7-8-4-10 1-1h10l12-3 8-6 4-7 1-4v-9l-3-10-2-4z",
    fill: "#322764"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(495,211)",
    d: "m0 0h5l15 31 2 5v6l-10 22-6 9-9 7-5 2-6 1h-8l-8-2 1-4 6-9 2-9-1-9-4-8-5-5-7-4-13-3 1-3 31-19 12-6z",
    fill: "#322764"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(221,973)",
    d: "m0 0 3 2 18 48 7 18-1 3-9 4-4-1-8-22v-2l-21 7-37 14-35 13h-4l-6-15 1-3 36-14 51-19 7-2-7-18-2-5v-3z",
    fill: "#FEFEFD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(477,1306)",
    d: "m0 0 5 2 11 6-1 5-13 24-14 24-10 18-9 15v4l36 21-1 5-5 8-5-2-29-16-21-12-1-3 14-25 14-24 14-25 14-24z",
    fill: "#FEFEFD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(710,143)",
    d: "m0 0h13l4 33 1 15-4-4-5 1-9 8-14 9-14 5h-2l2-16-2-10-7-16-10-14v-2l30-7z",
    fill: "#322764"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(255,1057)",
    d: "m0 0 3 1 7 15-4 4-98 49h-2l-8-15 2-4 90-45z",
    fill: "#FEFEFD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(944,1380)",
    d: "m0 0 4 1 4 15 19 80 3 11v6l-17 4-2-2-15-62-11-47v-2z",
    fill: "#FEFEFD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(306,269)",
    d: "m0 0h18l15 4 12 5v3l-14 11-14 12-15 12-2-4-9-7-6-7-2-5v-10l3-6 6-5z",
    fill: "#322764"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(534,1144)",
    d: "m0 0h9v2l-4 2 1 4h3l4 6 2 4 8 4 2 2 5 1 4 4 2 1v2h5l4 4 5 1 3 3 5 1 4 3 5 2 2 2 7 2 8 4h3l1 2h5l6 4 5 2 1-2 3 3 12 3v2l14 1v2l7 1 7 2v2l6 1 9 1 1 4h6v-1l7 1 8 4 9 1 2-2 3 2 2 1h3v2l7 1h6l1-2h6l-1 7-17-2-43-8-36-9-36-12-24-10-24-12-22-14-16-11-7-6-1-5z",
    fill: "#F22634"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(280,446)",
    d: "m0 0h7l1 4v7l-3 10-4 6-6 4-3 1h-9l-12-6-16-11-6-4 2-2z",
    fill: "#322865"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(989,903)",
    d: "m0 0 5 2 5 5 2 4 3 3v4l3 1v2l3 1 3 7 2 2v3h2l1 4 5 5 1 7 3 1v2l4 2v3l2 1v2l1 3h2v2h2l4 5 4 7v2l3 1 5 5 2 4 6 5 2 5h2v3l4 1v3l4 1v3h2v2h2l4 4v2l4 2 8 8 7 5v2l5 2 3 1v2l5 2v2l7 1 12 2h7l1 2 5-1-4 6 1 3-5 1h-7l-11-3-10-6-16-13-20-18-5-6-2-3v-3l-4-2v-2h-2v-3h-2v-2h-2v-2h-2l-7-8v-3l-3-1-2-5-2-1-6-7v-2h-2l-4-7-6-8-2-2v-4h-2l-4-6v-2h-2v-3h-2l-5-9-3-5v-2h-2l-10-18-2-1z",
    fill: "#F22634"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1043,1160)",
    d: "m0 0h5l-1 3 2 1-22 14-21 12-27 14-20 9-29 11-3-1h-3l-3 1-3-1v-2l-4 1v-2l7-3v2l-1 1h3l-1-5 4 2 1-3 7-1 1-2 2 1 2-2 17-7 9-3 5-3 5-2 18-9 7-2 1-3 9-3 4-1 3-1 1-3 3 1 1-4 4 1 1-2 7-2 1-3h3v-3l2 1-1 2h2z",
    fill: "#F12634"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(766,1412)",
    d: "m0 0h17l7 3 4 5 2 5v14l-4 8-4 3-3 1h-19l-2-3 1-35z",
    fill: "#332764"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,509)",
    d: "m0 0 1 2 3-1v3l4 1 1 3 4 2 4 4v2l4 2v2l3 1 5 6 8 6v2l4 1 11 9 8 6 5 2 2 3 14 7 5 3v2h5l3 3 6 2 4 2 5 2 13 6 7 3 1 3 3-1 3 2 2 8-26-10-16-7-22-12-18-12-12-9-11-9-13-12-6-7-5-7-1-3h-2v-2h-2l-5-7z",
    fill: "#F22634"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,605)",
    d: "m0 0 2 1 4 3-1 3-1-2-2 5h-3l2 6-1 2 2 1 1 2-1 6-1 4 4 8 2 9 1 2 5 2 2 2 14 4 12 1h7l9 6-2 2-11 3h-13l-13-4-10-6-9-10-5-10-2-6-1-7v-8l3-13 3-4v2h2z",
    fill: "#F22634"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(920,701)",
    d: "m0 0 2 1 1 2v6l-3 3v3 2h-3v2l3-1-1 6 1 7v2l3 8v6l3 2v2h2v2l5 2 4 3 7 2 10 2h5l1 2 4-1v4h2l1-4 1 2-1 2h6l1 2-5 2-6 1h-13l-12-3-10-6-9-9-7-14-2-9v-11l3-12 3-6 1 2h2z",
    fill: "#F22634"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(924,834)",
    d: "m0 0 5 2 2-2-1 5-5 5-1-1-1 4 1 3-1 1v3 12l3 4v6 2l2 4 2 1 2 4 3 2 4 1v3l4-1 7 3 12 1v2l3-1 3 2v3h3v2l-4 1h-15l-11-3-11-7-9-10-5-10-2-7v-16l4-13 3-3z",
    fill: "#F22634"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(672,632)",
    d: "m0 0h3l3 8v15h3l1 6 5 1 6 5 10 3 9 1 5 1 4-1 6-2 1 2-4 1v5h-3v2l5-2h3v2l-6 2-12 1-12-2-14-7-10-11 2-1-3-6-3-9v-13z",
    fill: "#F22634"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1015,738)",
    d: "m0 0 6 2h6l8 4 8 1 5 3 10 1 2 2 4 1 3 2 5-1 3 2v3l3-1 9 1 4 1 7 1v2h8l1 1 13 1-3 2-9 1-31-5-30-7-27-8-13-4-1-2z",
    fill: "#F22634"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(138,941)",
    d: "m0 0h41l2 1-2 4-23 13-11 5h-2l-4-12z",
    fill: "#322764"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(410,1299)",
    d: "m0 0 2 2-10 25-6 13-4-1-14-11-1-4 13-10 16-12z",
    fill: "#332764"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(819,468)",
    d: "m0 0 1 2h2l4 16-1 4 1 7h3l2 16 6 22 2 10 2 4-1 3-3-1-2-8h-2l-2-9-2-3-2-12-3-9-4-25-1-3z",
    fill: "#F32735"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,905)",
    d: "m0 0 6 1 2 5 6 11v2h2l8 14v2h2v3h2l4 6v2h2l2 5 4 5v2l3 1 2 4 1 4h2l4 5v2l3 1 4 7 2 1 3 5 4 4v2h2v2h2v2h2v3h2l4 4 2 4 2 2-4-1-11-11-9-11-11-13-14-19-14-21-14-23-7-11z",
    fill: "#E0252F"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(381,940)",
    d: "m0 0 3 3 1 6 3 4 3 9 8 15 5 9 4 8 3 7 2 1 1 7h2l8 16 2 1v3l2 1 1 4h-3l-7-11-6-9-6-11-7-12-1-5h-2l-5-13-4-8-3-8v-3l-2-1-2-6-1-5z",
    fill: "#F22634"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(441,1054)",
    d: "m0 0 2 1v2l4 2 4 7 3 1v3l15 5 6-1v2l5-2-1 5h-2v2h-2v2l-4 4h-10l-6-4-6-7-2-10-5-8z",
    fill: "#F22634"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(585,765)",
    d: "m0 0 4 1v2l5 2 5 3h2v2h2v2l5-1 6 3 2-1 4 1v2l4-1v3l4-1 1 2 6-1 5-1-3 3-11 3h-12l-13-4-9-6-7-8z",
    fill: "#F22634"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(365,754)",
    d: "m0 0h6l3 7 2 4 6 2 1 2 3 2v3l9 1-2 2-18-2-14-4-2-2 2-10h2z",
    fill: "#F12634"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,1209)",
    d: "m0 0 4 2 2 2-1 2 4 10v2l4-1 6 2 4 1-1 4h2v2h-6l-1 1 4 2-15 1v-2h-2l-3-4-2-16v-7z",
    fill: "#F22634"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(550,747)",
    d: "m0 0 2 1v4h2l-1 5-18 7-13 4h-2l-1-6h-2v-3l11-3 9-3 2-2 2 1 2-2h5v2l2-1z",
    fill: "#F12634"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(616,912)",
    d: "m0 0 4 1h4l3-1 1 1h11l4 2h-3v2l3-1v2h2v2l3 1-5 2h-14l-14-4-4-2 1-3h4z",
    fill: "#F22634"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,543)",
    d: "m0 0h7l5 2-1 2 9 5 1 2-4 1-2-1v2h-5l-3-1-7 1-1 3h-3l-1-3-5-3 6-7z",
    fill: "#F02634"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(976,540)",
    d: "m0 0 2 1-4 6-11 9-6 5h-2l1 3-16 11-2 1-4-2-3 1 1-3h5l1-6 1 2h2l1-3 4-4 3-1 3-3h2l5-1v-3l4-2 4-1 3-3 1-3 3-2z",
    fill: "#EF2633"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1136,526)",
    d: "m0 0h6v3l6 8-1 2h-3l-5 1h-7-3-7l6-8 1-3z",
    fill: "#F22634"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,830)",
    d: "m0 0 12 1 3 3 5 2-1 4-5 1-1-2-3-1v-2l-7 1h-7l-2-1v3l-6 2h-4v-4l4-2h3l-1-3z",
    fill: "#F22634"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,924)",
    d: "m0 0 3 1h-2v2l6 1 1 1 2 1-4 2v2l-7-2v-2h-2v-2h-3l-1 2-5-1-4 1-6 2v2l-6-2-1 3h-2l1 3-5 1-1 4-2-2v-4l3-1 1 1 1-3 3-1 4-5 8-3h17z",
    fill: "#F32735"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(868,918)",
    d: "m0 0h13l10 2v3l-5 1-5-1-7 1-3 2-10 1-1-2-1 2-3-1 1-5 5-2z",
    fill: "#F22634"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(833,954)",
    d: "m0 0 6 3v7l-3 1 2 4v10l3 4v3h-3l-5-8-2-9v-12z",
    fill: "#F32735"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(515,469)",
    d: "m0 0h4v3l4 1v2l-3 1 1 4 2 1v6l3 4-1 3h-2v-2h-2l-2-4-5-5-2-3v-7l-2-1z",
    fill: "#F22634"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1043,1160)",
    d: "m0 0h5l-1 3 2 1-22 14-15 9-3-1 5-3 2-3 6-2 11-7 1-2h2v-2h-2l1-3h3v-3l2 1-1 2h2z",
    fill: "#E1252F"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(809,610)",
    d: "m0 0 1 3-2 3-1 7v14l4 12 2 3v3h2v2l-4-2-5-10-2-6-1-7v-8l2-10z",
    fill: "#E2252F"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(918,840)",
    d: "m0 0h2l-3 18v12l6 12 2 3-1 3-4-5-4-8-2-7v-16l3-11z",
    fill: "#E42530"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1041,435)",
    d: "m0 0 7 4 9 7v2h4l-1 4v-2h-2v5l-5 1v-6-1-3l-4-2v-2l-5-1v-2l-4-2z",
    fill: "#F32735"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(844,933)",
    d: "m0 0 3 1-1 6-3 2v3l-6 2 1 3h-3v-8l2-4 5-2z",
    fill: "#F02634"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(914,708)",
    d: "m0 0h2l-2 12-1 17-2-3-1-2v-11l3-12z",
    fill: "#E22530"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(961,815)",
    d: "m0 0 13 1 6 3-3 2-11-1h-3l-4-4z",
    fill: "#F32735"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(750,924)",
    d: "m0 0 3 1h-2v2l6 1 1 1 2 1-4 2v2l-7-2v-2h-2v-2l-3-1v-2h5z",
    fill: "#F12634"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1037,432)",
    d: "m0 0h5l13 10 5 4-1 3-8-7-9-6-4-1z",
    fill: "#E32530"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(866,916)",
    d: "m0 0h19l-2 2-24 2-1-2z",
    fill: "#E32530"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,828)",
    d: "m0 0 3 1 1 7h-4-3l-2 1 1-5z",
    fill: "#E22530"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1043,1160)",
    d: "m0 0h5l-3 5-3 2h-3v-2l-5 2 1-3h3v-3l2 1-1 2h2z",
    fill: "#F32735"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(730,923)",
    d: "m0 0h18l2 1-1 2h-21l-1-2z",
    fill: "#E2252F"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(912,738)",
    d: "m0 0h2l5 11 2 3v3h2v2l-4-2-7-14z",
    fill: "#E2252F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,1131)",
    d: "m0 0 5 1 1 7-2 2h-3l-2-1 1-1z",
    fill: "#F22634"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(934,573)",
    d: "m0 0 1 2 3 1-9 6-4-2 2-4 6-2z",
    fill: "#E52531"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(976,540)",
    d: "m0 0 2 1-4 6-9 8h-2l-1-3 5-2 3-3 1-3 3-2z",
    fill: "#F32735"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,959)",
    d: "m0 0h1l2 19h-2l-2-7v-11z",
    fill: "#E1252F"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1121,765)",
    d: "m0 0 13 2-1 2-17-1 4-2z",
    fill: "#F02634"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(916,873)",
    d: "m0 0 3 1 4 8 2 3-1 3-4-5-4-8z",
    fill: "#E2252F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(947,683)",
    d: "m0 0h5l-3 5-3 1-3-2-1 3-1-2 4-4z",
    fill: "#F32735"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(970,549)",
    d: "m0 0m-1 1m-1 1m-1 1 1 3-11 8h-2v-2l4-1 2-4z",
    fill: "#E1252F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(951,816)",
    d: "m0 0h7l-3 1v2l-6 2v-2h-2l-1 4-1-3 3-3z",
    fill: "#F22634"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,473)",
    d: "m0 0h2l2 9 3 3v3l-3-1-4-7z",
    fill: "#E0252F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(400,776)",
    d: "m0 0h10l2 3-16-1z",
    fill: "#F12634"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(512,761)",
    d: "m0 0 2 2-3 4-5-1-1-3z",
    fill: "#F32735"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(580,751)",
    d: "m0 0 4 4 2 5-3 1v-2h-2l-2-7z",
    fill: "#F22634"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(670,649)",
    d: "m0 0 3 1 2 5 2 3v3l-3-1-4-9z",
    fill: "#E0252F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(926,1221)",
    d: "m0 0 3 1-2 3-8 2v-3z",
    fill: "#E32530"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(633,830)",
    d: "m0 0 8 1v1l-16 2 1-3z",
    fill: "#E22530"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(987,1035)",
    d: "m0 0 5 3 4 3v2l2 1h-3l-5-4v-2l-3-1z",
    fill: "#F32735"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1108,764)",
    d: "m0 0h12l-3 2-9 1z",
    fill: "#F32735"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,595)",
    d: "m0 0 5 2-1 3 4 2-1 2-8-6z",
    fill: "#EC2633"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNssClub);
export default __webpack_public_path__ + "static/media/nss-club.8bdff6511da3b3719c89e7bffba1a8b5.svg";
export { ForwardRef as ReactComponent };